// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"2442":"afcc1cbb2b7d0777","5443":"feda531bcaf16001","6350":"15d41f7614512247","7856":"c919beff48335de1"}[chunkId] + ".js";
};